import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import Axios from "axios";
import { Row, Col, Button, Modal, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

//ACTIONS
import * as GS_navSettingsActions from "../../../../../store/actions/globalSettings/GS_navSettings";

//STYLES
import * as ControllerStyles from "../styles/photoGallery";

//COMPONENTS
import GalleryAlbumSlot from "./albumSlot";

function Controller() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [albums, setAlbums] = useState([]);
    const [loaded, setLoaded] = useState(false);

    const addModalDefaultValues = {
        open: false,
        albumType: "",
        title: "",
        valid: false,
        touched: false
    };

    const [addModal, setAddModal] = useState(addModalDefaultValues);

    function handleCloseAddModal() {
        setAddModal(addModalDefaultValues);
    }

    const modalDefaultValues = {
        open: false,
        header: "",
        message: ""
    };

    const [modal, setModal] = useState(modalDefaultValues);

    function handleModalClose() {
        setModal(modalDefaultValues);
    }

    useEffect(() => {
        dispatch(GS_navSettingsActions.UpdateTitle("Photo and Video Gallery"));
        dispatch(GS_navSettingsActions.UpdateSelected("Media"));
        dispatch(GS_navSettingsActions.UpdateSubSelected("Photo and Video Gallery"));

        load();
    }, []);

    function load() {
        Axios.post("/pods/CPOD_PHOTOANDVIDEOGALLERY_ADMIN/checkDirectoryExist")
            .then((res) => {
                const data = res.data;
                if (data.error == "null") {
                    console.log(data);
                    setAlbums(data.albums);
                    setLoaded(true);
                }
            })
            .catch((err) => console.log(err));
    }

    function handleAddAlbumClick(type) {
        console.log(type);
        setAddModal((prevState) => {
            return { ...prevState, albumType: type, open: true };
        });
    }

    function handleAddAlbumTextChange(event) {
        const { value } = event.target;

        let isValid = false;
        if (value != "") {
            isValid = true;
        }

        setAddModal((prevState) => {
            return { ...prevState, title: value, valid: isValid };
        });
    }

    function handleAddAlubmTouched() {
        setAddModal((prevState) => {
            return { ...prevState, touched: true };
        });
    }

    function handleMoodalAddClick() {
        if (!addModal.valid) {
            setAddModal((prevState) => {
                return { ...prevState, touched: true };
            });
        } else {
            const data = { title: addModal.title.replaceAll(" ", "_"), albumType: addModal.albumType };
            console.log(data);
            Axios.post("/pods/CPOD_PHOTOANDVIDEOGALLERY_ADMIN/addAlbum", data)
                .then((res) => {
                    const data = res.data;
                    console.log(data);
                    if (data.error == "null") {
                        load();
                        setAddModal(addModalDefaultValues);
                    } else {
                        setModal({ header: "Add Album", message: data.message, open: true });
                    }
                })
                .catch((err) => console.log(err));
        }
    }

    return (
        <div>
            {loaded && (
                <div style={ControllerStyles.body}>
                    <div>
                        <Row>
                            <Col style={ControllerStyles.columnRight}>
                                <Button onClick={handleAddAlbumClick.bind(this, "photo")}>Add Photo Album</Button>
                                <Button onClick={handleAddAlbumClick.bind(this, "video")}>Add Video Album</Button>
                            </Col>
                        </Row>
                        <br />
                        <Row>
                            {albums.map((album, index) => {
                                return (
                                    <Col md="auto" style={ControllerStyles.columnPadding} key={index}>
                                        <GalleryAlbumSlot uuid={album.uuid} title={album.albumName} type={album.albumType} reloadAlbums={load} />
                                    </Col>
                                );
                            })}
                        </Row>
                    </div>

                    <Modal show={addModal.open} onHide={handleCloseAddModal}>
                        <Modal.Header closeButton>
                            <Modal.Title>{addModal.albumType == "photo" ? "Add Photo Album" : "Add Video Album"}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Form.Group>
                                <Form.Label>Name:</Form.Label>
                                <Form.Control
                                    isInvalid={addModal.touched && !addModal.valid ? true : false}
                                    type="text"
                                    onBlur={handleAddAlubmTouched}
                                    value={addModal.title}
                                    onChange={handleAddAlbumTextChange}
                                />
                                <Form.Control.Feedback type="invalid">Please enter a name</Form.Control.Feedback>
                            </Form.Group>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button onClick={handleMoodalAddClick}>Add</Button>
                            <Button onClick={handleCloseAddModal}>Close</Button>
                        </Modal.Footer>
                    </Modal>
                    <Modal show={modal.open} onHide={handleModalClose}>
                        <Modal.Header closeButton>
                            <Modal.Title>{modal.header}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>{modal.message}</Modal.Body>
                        <Modal.Footer>
                            <Button onClick={handleModalClose}>Close</Button>
                        </Modal.Footer>
                    </Modal>
                </div>
            )}
        </div>
    );
}

export default Controller;
